<template>
    <div id="report-agent-performance">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.agentWorkTimeCalendar') }}</h2>
                    </div>
                    <WorkTimeCalendar :title="$t('report.agentWorkTimeCalendar')" :filters="filters" :loading="loading" :data="data" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.agentBreakTime') }}</h2>
                    </div>
                    <BreakCount :title="$t('report.agentBreakTime')" :filters="filters" :loading="loading" :data="data" />
                </div>
                <a-divider />
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import WorkTimeCalendar from "./WorkTimeCalendar.vue";
import BreakCount from "./BreakCount.vue";

const log = log2("AgentWorktime");
export default {
    name: "AgentWorktime",
    components: {
        BreakCount,
        WorkTimeCalendar,
        ChartDoddleIcon,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {},
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.teamWorkCalendar(this.filters)
                .then((res) => {
                    log("teamWorkCalendar data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-agent-performance {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .title {
                    display: flex;
                    gap: 4px;
                    align-items: center;

                    justify-content: center;

                    h2 {
                        text-align: center;
                        font-weight: 700;
                        font-size: 40px;
                        margin: 0 !important;
                    }
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
